import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import "@/App.css";
import PublicTripViewer from "@/pages/public/PublicTripViewer";
import AdminImport from "@/pages/AdminImport";
import Landing from "@/pages/Landing";

function PayRedirect() {
  const { token } = useParams();
  return <Navigate to={`/trip/${token}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/trip/:token" element={<PublicTripViewer />} />
        <Route path="/td/:token" element={<PublicTripViewer />} />
        <Route path="/pay/:token" element={<PayRedirect />} />
        <Route path="/admin" element={<AdminImport />} />
        <Route path="/" element={<Landing />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
